import { default as connectionService } from "./lib/autobahn/connection";
import { SECURE_WS_URI, WAMP_REALM_URI } from "./constants/constants";

export class SubsConnectionWSShared {
  private static instance: SubsConnectionWSShared;
  public connection: any = null;
  private url: string;
  private realm: string;
  private authmethods: string[];
  private authid: any;
  private connectionCheckTimeout: any = null;
  private closedByClient: boolean;
  private TIME_TO_WAIT_MS: number = 1000 * 6; // 6 seconds to give Autobahn time to reconnect

  private constructor({ fnConnOnOpen, fnConnOnClose }) {
    this.url = SECURE_WS_URI;
    this.realm = WAMP_REALM_URI;
    this.authmethods = ["oauth2"];
    this.authid = connectionService.getAuthId();
    this.closedByClient = false;

    const customOnClose = (reason, details) => {
      console.log("Connection closed. Reason:", reason, details);
      fnConnOnClose(reason, details);

      // If Autobahn's reconnect is active, we start our monitoring timer
      if (details.will_retry) {
        console.log("Autobahn will try to reconnect. Starting monitoring...");
        if (this.connectionCheckTimeout) {
          clearTimeout(this.connectionCheckTimeout);
        }

        this.connectionCheckTimeout = setTimeout(() => {
          if (
            Boolean(SubsConnectionWSShared.instance) &&
            !SubsConnectionWSShared.instance.connection.isConnected
          ) {
            console.log(
              "Automatic reconnection failed. Forcing a new connection."
            );
            // Force the closure and instance to create a new one
            SubsConnectionWSShared.closeConnection();
            SubsConnectionWSShared.getInstance({ fnConnOnOpen, fnConnOnClose });
          }
        }, this.TIME_TO_WAIT_MS);
      }
      if (reason === "lost" && !details.reason && !details.will_retry) {
        if (!SubsConnectionWSShared.instance?.connection?.isConnected) {
          console.log(
            "Automatic reconnection failed. Forcing a new connection."
          );
          SubsConnectionWSShared.getInstance({ fnConnOnOpen, fnConnOnClose });
        }
      }
    };

    const customOnOpen = (session, details) => {
      console.log("WAMP connection successful.");
      if (this.connectionCheckTimeout) {
        clearTimeout(this.connectionCheckTimeout);
        this.connectionCheckTimeout = null;
      }
      fnConnOnOpen(session, details);
    };

    this.connection = connectionService.establishWsConnection(
      this.url,
      this.realm,
      this.authmethods,
      this.authid,
      { customOnOpen, customOnClose }
    );
  }

  public static getInstance({
    fnConnOnOpen,
    fnConnOnClose
  }): SubsConnectionWSShared {
    if (
      !Boolean(SubsConnectionWSShared.instance) ||
      !SubsConnectionWSShared.instance.connection.isConnected
    ) {
      SubsConnectionWSShared.instance = new SubsConnectionWSShared({
        fnConnOnOpen,
        fnConnOnClose
      });
    }
    return SubsConnectionWSShared.instance;
  }

  public static isConnectionOpen() {
    return (
      Boolean(SubsConnectionWSShared.instance) &&
      SubsConnectionWSShared.instance.connection?.isConnected
    );
  }

  public static isClosedByClient() {
    return SubsConnectionWSShared.instance.closedByClient;
  }

  public static closeConnection() {
    if (Boolean(SubsConnectionWSShared.instance)) {
      SubsConnectionWSShared.instance.closedByClient = true;
      SubsConnectionWSShared.instance.connection?.close();
      SubsConnectionWSShared.instance = null;
    }
  }
}
